export const ugovor_o_pristupanju_dugu = {
  templateId: 24,
  category: 2,
  templateTitle: "Ugovor o pristupanju dugu",
  templateDescription: `Pristupanje dugu je ugovor između vjerovnika i trećega (pristupatelja dugu), kojim se pristupatelj dugu obvezuje vjerovniku da će ispuniti tražbinu koju vjerovnik ima prema dužniku te navedenim ugovorom pristupatelj dugu stupa u obvezu pored dužnika. Za točniji odabir načina reguliranja međusobnih odnosa predlažemo da koristite <a target="_blank" href="http://solucio-debit.com">Solucio Debit app</a>.`,
  description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p><strong>Pristupanje dugu je ugovor između vjerovnika i trećega (pristupatelja dugu), kojim se pristupatelj dugu obvezuje vjerovniku da će ispuniti njegovu tražbinu prema dužniku.</strong></p>
    <p>Ukoliko želite provjeriti hoće li ova vrsta ugovora biti ispravan odabir za međusobno reguliranje odnosa, predlažemo korištenje aplikacije <a target="_blank" href="http://solucio-debit.com">Solucio Debit app</a> koja će brzo i točno dati rješenje za vašu situaciju. </p>
    <p>Treći (pristupatelj dugu) stupa u obvezu pored dužnika, s time da se može obvezati da će ispuniti cjelokupni dug dužnika ili samo dio duga.</p> 
    <p>Ugovor o pristupanju dugu se sklapa između vjerovnika i trećega (pristupatelja dugu), bez sudjelovanja dužnika. Ugovor je moguće sklopiti čak iako se dužnik tomu protivi, no svakako dužnik nema pravne osnove protiviti se ispunjenju duga od strane treće osobe.</p>
  
    
    Ipak, postoje dvije pretpostavke koje moraju biti kumulativno ispunjene da bi ispunjenje duga od strane preuzimatelja duga bilo valjano:
    <ul>
    <br>
      <li><strong> obveza mora biti dospjela, i</strong></li>
      <li><strong> neispunjena od strane dužnika.</strong></li>
    </ul>
    <p>Vjerovnik ovim ugovorom dobiva "dva dužnika" (dužnika i pristupatelja duga), jer već otprije ima pravo tražiti ispunjenje bilo od dužnika, a ovim ugovorom stječe potraživanje prema trećemu (pristupatelju dugu).</p> 
    <p>Međutim, odnos između dužnika i pristupatelja dugu ne može biti solidaran, jer solidarnost između dužnika i pristupatelja dugu ne može postojati budući  da između njih nema nikakvog pravnog odnosa.</p> 
    <p>Također, nema niti regresnog odnosa (eventualnog prava naplate od osobe umjesto koje je ispunjen dug), jer pristupatelj dugu nije u ugovornom odnosu s dužnikom. </p> 
    <p>Pristupanjem treće osobe tuđem dugu, stari dužnik se ne oslobađa svoje obveze i njegov pravni položaj&nbsp; ostaje neizmijenjen.</p>
    <p><strong>NAPOMENA: Dužnik (poslovni subjekt) kojemu je blokiran račun odnosno koji ima oznaku zabranu raspolaganja oročenim novčanim sredstvima ne smije svoje obveze plaćati gotovim novcem, plaćati preko institucije za platni promet niti preko ostalih pružatelja platnih usluga u Republici Hrvatskoj, kao niti plaćati ili primati plaćanja preko računa otvorenog kod pružatelja platnih usluga u inozemstvu, a ne smije niti preusmjeravati novčane i financijske tijekove na drugu osobu niti primati uplate i isplaćivati novčana sredstva na račune drugih osoba.</strong><p>
  
    <h5><strong>NAJČEŠĆE GREŠKE</strong></h5>
    <p><strong>- Ispunjenje obveza koje nisu dospjele</strong></p>
    <p> Pojašnjenje: da bi ispunjenje od strane pristupatelja duga bilo valjano, obveza dužnika prema vjerovniku mora biti dospjela te neispunjena od strane dužnika.</p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o obveznim odnosima.</p>
  `,

  sides: [
    {
      prefix: "VJEROVNIK:",
      signature: "VJEROVNIK",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      delimiter: "i"
    },
    {
      prefix: "\r\nPRISTUPATELJU DUGU:",
      signature: "PRISTUPATELJ DUGU",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }
    ],
    suffix: ","
    },
  ],

  headline: "zaključuju sljedeći",
  title: "UGOVOR O PRISTUPANJU DUGU",

  articles: [
    {
      title: 'DUG DUŽNIKA',
      mandatory: true,
      statements: [
          {
              type: 'input',
              mandatory: true,
              editable: false,
              parts: [
                
                  { type: "text", content: "VJEROVNIK ima nepodmirenu dospjelu tražbinu prema" },
                  { type: "input", value: "", required: true, placeholder: "Naziv dužnika",},
                  { type: "text", content: "," },
                  { type: "input", value: "", required: true, placeholder: "Mjesto"  },
                  { type: "text", content: "," },
                  { type: "input", value: "", required: true, placeholder: "Ulica i kućni broj"  },
                  { type: "text", content: ", OIB:" },
                  { type: "input", value: "", required: true,  placeholder: "Unesite OIB",},
                  { type: "text", content: "(u daljnjem tekstu: DUŽNIK), iznos od",  }, 
                  { type: "input", value: '', required: true, help: "Unijeti iznos i valutu.",}, 
                  { type: "text", content: "" },
              ]
          },
     
      ],
  },
    {
      title: "PREDMET UGOVORA",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Sklapanjem ovog Ugovora, PRISTUPATELJ DUGU stupa pored DUŽNIKA u obvezu prema VJEROVNIKU u iznosu i opsegu pristupanja dugu koji je određen ovim Ugovorom."
        }
      ]
    },
    {
      title: "OPSEG PRISTUPANJA DUGU",
      mandatory: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Ovim Ugovorom, PRISTUPATELJ DUGU preuzima obvezu ispuniti VJEROVNIKOVU tražbinu prema DUŽNIKU i to u cjelokupnom iznosu navedenom u ovom Ugovoru." }
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim Ugovorom, PRISTUPATELJ DUGU djelomično preuzima obvezu ispuniti VJEROVNIKOVU tražbinu prema DUŽNIKU i to u iznosu od" },
                { type: "input", value: "", help: "Ukoliko želite ugovoriti da Pristupatelj dugu pristupa samo dijelu duga iz ovog Ugovora, onda odaberite ovu opciju i unesite iznos.", required: true },
              ]
            }
          ],
        }
      ]
    },
   
    {
      title: "SAMOSTALNOST OBVEZE",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Obveza PRISTUPATELJA DUGU iz ovog Ugovora samostalna je u odnosu na obvezu DUŽNIKA navedenu u ovom Ugovoru."
        }
      ]
    },
    // {
    //   title: "NESOLIDARNOST",
    //   mandatory: false,
    //   statements: [
    //     {
    //       type: "text",
    //       mandatory: true,
    //       editable: false,
    //       content: "Pristupanjem dugu DUŽNIKA, obveza DUŽNIKA i PRISTUPATELJA DUGU ne postaje solidarna."
    //     }
    //   ]
    // },
    {
      title: "PRISTANAK DUŽNIKA",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Za pravovaljanost ovog Ugovora nije potreban pristanak DUŽNIKA."
        }
      ]
    },
    {
      title: "MJERODAVNO PRAVO",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Ugovorne strane suglasno utvrđuju da će se na sve odnose koji nisu riješeni ovim Ugovorom primjenjivati odredbe važećih propisa Republike Hrvatske, a primarno odredbe Zakona o obveznim odnosima."
        }
      ]
    },
    {
      title: "NADLEŽNOST",
      mandatory: false,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu VJEROVNIKA." }
              ]
            },
            {
              parts: [
                { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu PRISTUPATELJA DUGU." }
              ]
            },
            {
              parts: [
                { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u " },
                { type: "input", value: "", help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true },
              ]
            }
          ],
        }
      ]
    },
    {
      title: "PRIMJENA UGOVORA",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Ugovor se primjenjuje od trenutka potpisa ugovornih strana."
        }
      ]
    },
    {
      title: 'PRIMJERCI UGOVORA',
      mandatory: false,
      statements: [
          {
              type: 'text',
              required: false,
              mandatory: true,
              editable: true,
              content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
              value: '',
          }],
    },
  {
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          {
            type: "text",
            content: "U"
          },
          {
            type: "input",
            value: "",
            placeholder: "Upišite mjesto.",
            required: true,
          },
          {
            type: "text",
            content: ", dana"
          },
          {
            type: "date",
            value: new Date(),
            required: true
          },
          {
            type: "text",
            content: "godine."
          }
        ]
      },
    ]
  },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    },
  ],
}; 


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/24_ugovor_o_pristupanju_dugu.ts